import { render, staticRenderFns } from "./projekte.vue?vue&type=template&id=34e444ec&"
import script from "./projekte.vue?vue&type=script&lang=js&"
export * from "./projekte.vue?vue&type=script&lang=js&"
import style0 from "./projekte.vue?vue&type=style&index=0&id=34e444ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadCrumbs: require('/vercel/path0/components/ui/BreadCrumbs.vue').default,Container: require('/vercel/path0/components/ui/Container.vue').default,WizardSteps: require('/vercel/path0/components/wizard/WizardSteps.vue').default,WizardChildComponent: require('/vercel/path0/components/wizard/WizardChildComponent.vue').default,Wizard: require('/vercel/path0/components/wizard/Wizard.vue').default,KurzcheckError: require('/vercel/path0/components/application-forms/KurzcheckError.vue').default,BaseLayout: require('/vercel/path0/components/application-forms/BaseLayout.vue').default})
